const blobByDataUrl = new Map<string, string>()
const dataByBlobUrl = new Map<string, string>()

const DATA_IMAGE_SRC = /src=(['"])(data:image\/[a-zA-Z0-9.+-]+;base64,[^'"]+)\1/g

function blobUrlForDataImage(dataUrl: string): string {
    const cached = blobByDataUrl.get(dataUrl)
    if (cached) {
        dataByBlobUrl.set(cached, dataUrl)
        return cached
    }
    const comma = dataUrl.indexOf(",")
    if (comma < 0) {
        return ""
    }
    const mime = /^data:([^;]+)/.exec(dataUrl)?.[1] || "image/jpeg"
    let binary: string
    try {
        binary = atob(dataUrl.slice(comma + 1))
    } catch {
        return ""
    }
    const bytes = new Uint8Array(binary.length)
    for (let i = 0; i < binary.length; i++) {
        bytes[i] = binary.charCodeAt(i)
    }
    let blobUrl = ""
    try {
        blobUrl = URL.createObjectURL(new Blob([bytes], {type: mime}))
    } catch {
        return ""
    }
    blobByDataUrl.set(dataUrl, blobUrl)
    dataByBlobUrl.set(blobUrl, dataUrl)
    return blobUrl
}

const BLOB_SRC = /src=(['"])(blob:[^'"]+)\1/g

/** Перед записью шаблона и договора blob: из этой вкладки возвращаем в data URI. Чужой blob: не из чего восстановить. */
export function restoreBlobUrlsToDataImages(html: string): string {
    if (!html || html.indexOf("blob:") === -1 || dataByBlobUrl.size === 0) {
        return html
    }
    return html.replace(BLOB_SRC, (match, quote: string, blobUrl: string) => {
        const dataUrl = dataByBlobUrl.get(blobUrl)
        if (!dataUrl) {
            return match
        }
        return `src=${quote}${dataUrl}${quote}`
    })
}

/** В редакторе data URI фото заменяем на blob:. Иначе каждая правка поля заново прогоняет все снимки через HTML документа. */
export function replaceDataImageSrcsWithBlobUrls(html: string): string {
    if (!html || html.indexOf("data:image") === -1) {
        return html
    }
    if (typeof URL === "undefined" || typeof URL.createObjectURL !== "function" || typeof atob !== "function") {
        return html
    }
    return html.replace(DATA_IMAGE_SRC, (match, quote: string, dataUrl: string) => {
        const blobUrl = blobUrlForDataImage(dataUrl)
        if (!blobUrl) {
            return match
        }
        return `src=${quote}${blobUrl}${quote}`
    })
}
